import { Group, type GroupProps } from '@mantine/core'
import type { ReactNode } from 'react'

type Props = Omit<GroupProps, 'justify' | 'children'> & {
  /** Слева: мета, фильтры */
  leading?: ReactNode
  /** Справа: действия */
  trailing?: ReactNode
  children?: ReactNode
}

/** Строка под заголовком: слева мета/текст, справа кнопки */
export function PageToolbar({ leading, trailing, children, gap = 'md', ...props }: Props) {
  if (children) {
    return (
      <Group justify="space-between" align="center" wrap="wrap" gap={gap} {...props}>
        {children}
      </Group>
    )
  }
  return (
    <Group justify="space-between" align="center" wrap="wrap" gap={gap} {...props}>
      <Group gap="xs" wrap="wrap" style={{ flex: 1, minWidth: 0 }}>
        {leading}
      </Group>
      <Group gap="sm" wrap="wrap" justify="flex-end">
        {trailing}
      </Group>
    </Group>
  )
}
